import lazyLoad from 'app/shared-components/util/lazyLoad';
import { Navigate } from 'react-router-dom';
import authRoles from '../../../auth/authRoles';

const ComingSoonPage = lazyLoad(() => import('./ComingSoonPage'));

const ComingSoonPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'pages/home',
      element: <Navigate to="/" />,
    },
  ],
};

export default ComingSoonPageConfig;
